import { useState, useCallback, useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

import "./App.css";

export default function App() {
  return (
    <div className="appTop">
      <TicTac />
    </div>
  );
}

function TicTac() {
  const audioRef = useRef(null);
  const audioRefBot = useRef(null);

  const { initialScore, initial, lines } = useSelector((state) => state.static);

  // check if win
  const decideWinner = useCallback(
    (squares) => {
      for (let i = 0; i < lines.length; i++) {
        const [a, b, c] = lines[i];
        if (
          squares[a] &&
          squares[a] === squares[b] &&
          squares[a] === squares[c]
        ) {
          return [a, b, c];
        }
      }
      return false;
    },
    [lines]
  );

  // initial history
  const [history, setHistory] = useState([...initial]);

  // initial step
  const [currentStep, setCurrentStep] = useState(0);

  // initial squares set
  const currentSquares = history[currentStep];

  // player
  const [symbol, setSymbol] = useState("X");
  const [whoStart, setWhoStart] = useState("X");

  // game flags
  const [bot, setBot] = useState(true);
  const [pause, setPause] = useState(true);
  const [init, setInit] = useState(true);

  // bot types
  const [stup, setStup] = useState(false);
  const [idi, setIdi] = useState(false);
  const [intelli, setIntelli] = useState(false);
  const [geni, setGeni] = useState(false);
  const [excep, setExcep] = useState(true);

  // win history
  const [autoWin, setAutoWin] = useState(0);
  const [playerWin, setPlayerWin] = useState(0);
  const [total, setTotal] = useState(0);

  // scoreboard
  const [score, setScore] = useState(JSON.parse(JSON.stringify(initialScore)));
  const [showScore, setShowScore] = useState(false);

  // calculate tie
  let tieWin = useMemo(
    () => total - (autoWin + playerWin),
    [autoWin, playerWin, total]
  );

  // set auto player
  let auto = "";
  if (symbol === "X") {
    auto = "O";
  } else {
    auto = "X";
  }
  // set whose second turn
  let other = "";
  if (whoStart === symbol) {
    other = auto;
  } else {
    other = symbol;
  }

  // set whose next turn
  let whoNext = currentStep % 2 === 0 ? whoStart : other;

  // set game status
  let status = "";

  if (whoNext === auto && bot) {
    status = "Bot(" + whoNext + ") turn!";
  } else if (whoNext === auto && !bot) {
    status = "Other(" + whoNext + ") turn!";
  } else {
    status = "Your(" + whoNext + ") turn!";
  }

  // set tied status
  let leftSpace = true;

  leftSpace = useMemo(
    () => currentSquares.filter((item) => item === undefined).length,
    [currentSquares]
  );
  if (!leftSpace) {
    status = "Game tied!";
  }

  // set win status
  let won = useMemo(
    () => decideWinner(currentSquares),
    [decideWinner, currentSquares]
  );

  if (won) {
    let winner = whoNext === symbol ? auto : symbol;
    if (winner === auto && bot) {
      status = "Bot(" + winner + ") won!";
    } else if (winner === auto && !bot) {
      status = "Other(" + winner + ") won!";
    } else {
      status = "You(" + winner + ") won!";
    }
  }

  // set robot
  let robot = "";
  if (intelli) {
    robot = "Intelligent";
  } else if (idi) {
    robot = "Average";
  } else if (geni) {
    robot = "Genius";
  } else if (stup) {
    robot = "Stupid";
  } else if (excep) {
    robot = "Exceptional";
  }

  // update game scores

  // won history updater
  const wonUpdater = useCallback(() => {
    if (won) {
      let winner = whoNext === symbol ? auto : symbol;
      if (winner === auto) {
        setAutoWin((win) => win + 1);
        bot
          ? (() => {
              setScore((score) => {
                const initial = JSON.parse(JSON.stringify(score));
                initial[robot]["lose"] += 1;
                return initial;
              });
              setScore((score) => {
                const initial = JSON.parse(JSON.stringify(score));
                initial[robot]["total"] += 1;
                return initial;
              });
            })()
          : (() => {
              setScore((score) => {
                const initial = JSON.parse(JSON.stringify(score));
                initial["Other Human"]["lose"] += 1;
                return initial;
              });
              setScore((score) => {
                const initial = JSON.parse(JSON.stringify(score));
                initial["Other Human"]["total"] += 1;
                return initial;
              });
            })();
      } else {
        setPlayerWin((win) => win + 1);
        bot
          ? (() => {
              setScore((score) => {
                const initial = JSON.parse(JSON.stringify(score));
                initial[robot]["win"] += 1;
                return initial;
              });
              setScore((score) => {
                const initial = JSON.parse(JSON.stringify(score));
                initial[robot]["total"] += 1;
                return initial;
              });
            })()
          : (() => {
              setScore((score) => {
                const initial = JSON.parse(JSON.stringify(score));
                initial["Other Human"]["win"] += 1;
                return initial;
              });
              setScore((score) => {
                const initial = JSON.parse(JSON.stringify(score));
                initial["Other Human"]["total"] += 1;
                return initial;
              });
            })();
      }
      setTotal((total) => total + 1);
    }
  }, [won]);

  // update won history
  useEffect(wonUpdater, [wonUpdater]);

  // tie history updater
  const tieUpdater = useCallback(() => {
    if (!leftSpace && !won) {
      setTotal((total) => total + 1);

      bot
        ? (() => {
            setScore((score) => {
              const initial = JSON.parse(JSON.stringify(score));
              initial[robot]["tie"] += 1;
              return initial;
            });
            setScore((score) => {
              const initial = JSON.parse(JSON.stringify(score));
              initial[robot]["total"] += 1;
              return initial;
            });
          })()
        : (() => {
            setScore((score) => {
              const initial = JSON.parse(JSON.stringify(score));
              initial["Other Human"]["tie"] += 1;
              return initial;
            });
            setScore((score) => {
              const initial = JSON.parse(JSON.stringify(score));
              initial["Other Human"]["total"] += 1;
              return initial;
            });
          })();
    }
  }, [leftSpace, won]);

  // update tie history
  useEffect(tieUpdater, [tieUpdater]);

  // update squares set
  const handleNext = useCallback(
    (newSquares) => {
      const newRecords = [...history.slice(0, currentStep + 1), newSquares];
      setHistory(newRecords);
      setCurrentStep(newRecords.length - 1);
    },
    [history, currentStep]
  );

  // adjust progress
  const revertTo = useCallback((step) => {
    setCurrentStep(step);
  }, []);

  // reset game stats
  const reset = useCallback(() => {
    setHistory(initial);
    setCurrentStep(0);
    setInit(true);
    setPause(true);
    setGeni(false);
    setIdi(false);
    setIntelli(false);
    setStup(false);
    setWhoStart("X");
    setSymbol("X");
    setBot(true);
    setExcep(true);
    setAutoWin(0);
    setPlayerWin(0);
    setTotal(0);
  }, [initial]);

  const symbolNext = useCallback(
    (step, description, key) => {
      return (
        <li
          style={{
            marginBottom: 10,
          }}
          key={key}
        >
          <button
            className={whoNext === symbol ? "step-you" : "step-bot"}
            disabled={whoNext === symbol ? false : true}
            key={step}
            onClick={() => revertTo(step)}
          >
            {description}
          </button>
        </li>
      );
    },
    [whoNext, symbol, revertTo]
  );

  const playAgain = useCallback(
    (step, description, key) => {
      description = "Play again";
      return (
        <li style={{ marginBottom: 10 }} key={key}>
          <button
            className={won || !leftSpace ? "step-you game-button" : "step-bot"}
            disabled={won || !leftSpace ? false : true}
            key={step}
            onClick={() => {
              revertTo(step);
              setCurrentStep(0);
              setHistory(initial);
              whoStart !== auto && bot ? setPause(true) : setPause(false);
              setWhoStart((whoStart) => (whoStart === auto ? symbol : auto));
            }}
          >
            {description}
          </button>
        </li>
      );
    },
    [
      won,
      leftSpace,
      revertTo,
      setCurrentStep,
      setHistory,
      initial,
      auto,
      symbol,
      whoStart,
      bot,
    ]
  );

  const recentButton = useCallback(
    (step, description, key) => {
      description = "Move back to recent #" + step;
      return (
        <li style={{ marginBottom: 10 }} key={key}>
          <button
            className={won || !leftSpace ? "step-you" : "step-bot"}
            disabled={won || !leftSpace ? false : true}
            key={step}
            onClick={() => revertTo(step)}
          >
            {description}
          </button>
        </li>
      );
    },
    [won, leftSpace, revertTo]
  );

  // set steps
  const steps = history.map((el, step) => {
    let description = "move to ";
    if (step === 0) {
      description += "Start";
    } else {
      description += "step #" + step;
    }
    // if not end
    if (!won && leftSpace) {
      // if opponent starts
      if (whoStart === auto) {
        // if bot start, only you turns steps
        if (bot) {
          if (step % 2) {
            let buttons = symbolNext(step, description, step);
            return buttons;
          } else {
            return undefined;
          }
        } else if (!bot) {
          if (step === 0) {
            let playButton = playAgain(step, description, step);
            return playButton;
          } else if (step === history.length - 1 && step !== 0) {
            let recent = recentButton(step, description, step);
            return recent;
          } else {
            return undefined;
          }
        } else {
          return undefined;
        }
      } else {
        if (bot) {
          if (!(step % 2)) {
            let buttons = symbolNext(step, description, step);
            return buttons;
          } else {
            return undefined;
          }
        } else if (!bot) {
          if (step === 0) {
            let playButton = playAgain(step, description, step);
            return playButton;
          } else if (step === history.length - 1 && step !== 0) {
            let recent = recentButton(step, description, step);
            return recent;
          } else {
            return undefined;
          }
        } else {
          return undefined;
        }
      }
      // if end
    } else {
      if (step === 0) {
        let playButton = playAgain(step, description, step);
        return playButton;
      } else {
        return undefined;
      }
    }
  });

  return (
    <div className="tictac">
      <audio ref={audioRef} src="./click1.wav" preload="auto" />
      <audio ref={audioRefBot} src="./click2.wav" preload="auto" />
      <header className="header">
        <h2>Tic Tac Plus</h2>
      </header>
      {init && pause ? (
        !showScore ? (
          <>
            <div className="settings-container">
              {/*column */}

              <div className="settingRows game-settings">
                <div className="chooseOptions1" style={{ marginBottom: 10 }}>
                  {/*row */}
                  <div>
                    <label
                      style={{ marginRight: 15, marginBottom: 15, padding: 5 }}
                    >
                      Choose player
                      <select
                        name="Choose player"
                        onChange={(e) =>
                          e.target.value === "X"
                            ? setSymbol("X")
                            : setSymbol("O")
                        }
                      >
                        <option value="X">X</option>
                        <option value="O">O</option>
                      </select>
                    </label>
                  </div>
                  <div>
                    <label
                      style={{ marginBottom: 15, marginRight: 15, padding: 5 }}
                    >
                      Choose who start
                      <select
                        name="Choose who start"
                        onChange={(e) =>
                          e.target.value === "X"
                            ? setWhoStart("X")
                            : setWhoStart("O")
                        }
                      >
                        <option value="X">X</option>
                        <option value="O">O</option>
                      </select>
                    </label>
                  </div>
                </div>
                <div className="chooseOptions1" style={{ marginBottom: 10 }}>
                  <div>
                    <label style={{ marginBottom: 15, padding: 5 }}>
                      Choose opponent
                      <select
                        name="Choose opponent"
                        onChange={(e) =>
                          e.target.value === "robot"
                            ? setBot(true)
                            : setBot(false)
                        }
                      >
                        <option value="robot">Robot</option>
                        <option value="human">Human</option>
                      </select>
                    </label>
                  </div>
                  {bot ? (
                    <div>
                      <label style={{ marginBottom: 15, padding: 5 }}>
                        Choose Bot type
                        <select
                          name="Choose bot type"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value === "stup") {
                              setStup(true);
                              setExcep(false);
                              setGeni(false);
                              setIdi(false);
                              setIntelli(false);
                            } else if (value === "idi") {
                              setStup(false);
                              setGeni(false);
                              setExcep(false);
                              setIdi(true);
                              setIntelli(false);
                            } else if (value === "intelli") {
                              setIntelli(true);
                              setExcep(false);
                              setStup(false);
                              setGeni(false);
                              setIdi(false);
                            } else if (value === "geni") {
                              setGeni(true);
                              setStup(false);
                              setIdi(false);
                              setExcep(false);
                              setIntelli(false);
                            } else if (value === "excep") {
                              setGeni(false);
                              setExcep(true);
                              setStup(false);
                              setIdi(false);
                              setIntelli(false);
                            }
                          }}
                        >
                          <option value="excep">Exceptional</option>
                          <option value="geni">Genius</option>
                          <option value="intelli">Intelligent</option>
                          <option value="idi">Average</option>
                          <option value="stup">Stupid</option>
                        </select>
                      </label>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/*column*/}
              </div>
              {/* row*/}
              {/*column */}
              <div
                className="settingRows start-button"
                style={{ marginBottom: 20 }}
              >
                {/*row */}
                <div>
                  <button
                    className="game-button"
                    style={{ marginLeft: 15, marginBottom: 15, padding: 10 }}
                    value="Start game"
                    onClick={() => {
                      setInit(false);
                      if (bot && whoStart === auto) {
                        setPause(true);
                      } else {
                        setPause(false);
                      }
                    }}
                  >
                    Start game
                  </button>
                </div>
                {/*row */}
                <div>
                  <button
                    className="game-button"
                    style={{ marginLeft: 15, marginBottom: 15, padding: 10 }}
                    value="Scoreboard"
                    onClick={() => {
                      setShowScore(true);
                    }}
                  >
                    Scoreboard
                  </button>
                </div>
              </div>
            </div>
            <div className="overlay"></div>
          </>
        ) : (
          <>
            <div className="settings-container scoreboard-container">
              <div className="scoreTable">
                <ScoreRows score={score}></ScoreRows>
              </div>
              <div
                className="settingRows start-button"
                style={{ marginBottom: 20 }}
              >
                {/*row */}
                <div>
                  <button
                    className="game-button"
                    style={{ marginLeft: 15, marginBottom: 15, padding: 10 }}
                    value="Settings"
                    onClick={() => {
                      setShowScore(false);
                    }}
                  >
                    Settings
                  </button>
                </div>
                {/*row */}
                <div>
                  <button
                    className="game-button"
                    style={{ marginLeft: 15, marginBottom: 15, padding: 10 }}
                    value="Start game"
                    onClick={() => {
                      setInit(false);
                      setShowScore(false);
                      if (bot && whoStart === auto) {
                        setPause(true);
                      } else {
                        setPause(false);
                      }
                    }}
                  >
                    Start game
                  </button>
                </div>
                {JSON.stringify(score) !== JSON.stringify(initialScore) ? (
                  <div>
                    <button
                      className="game-button"
                      style={{ marginLeft: 15, marginBottom: 15, padding: 10 }}
                      value="Reset scores"
                      onClick={() => {
                        setScore(initialScore);
                      }}
                    >
                      Reset score
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="overlay"></div>
          </>
        )
      ) : (
        <div className="startHeader">
          <div
            className="choosenSetting"
            style={{ textAlign: "center", marginBottom: 20 }}
          >
            <span style={{ marginRight: 15 }}>
              Opponent:{" "}
              <span className="valueEach">
                {bot ? "Bot(" + auto + ")" : "Human(" + auto + ")"}
              </span>
            </span>
            {bot ? (
              <span>
                Bot: <span className="valueEach">{robot}</span>
              </span>
            ) : (
              <span>
                Human: <span className="valueEach">Other</span>
              </span>
            )}
            <div className="play-history">
              <span style={{ marginRight: 20 }}>
                {bot ? (
                  <span>
                    {robot}: <span className="won-history">{autoWin}</span>
                  </span>
                ) : (
                  <span>
                    Other: <span className="won-history">{autoWin}</span>
                  </span>
                )}
              </span>
              <span style={{ marginRight: 20 }}>
                <span>
                  You: <span className="won-history">{playerWin}</span>
                </span>
              </span>
              <span>
                <span>
                  Tie: <span className="won-history">{tieWin}</span>
                </span>
              </span>
            </div>
          </div>
          <div
            className="game-status"
            style={{ textAlign: "center", marginBottom: 15 }}
          >
            Game status:{" "}
            <span className="valueEach" id="statusMessage">
              {status}
            </span>
          </div>
          {won || !leftSpace ? (
            <div>
              <button
                className="game-button"
                style={{ marginLeft: 15, marginBottom: 10, padding: 10 }}
                value="Restart"
                onClick={reset}
              >
                Restart
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      )}

      <div className="board-steps">
        {/*column*/}
        <div id="boardContainer">
          {won || !leftSpace ? <p className="game-over">{status}</p> : ""}
          <SquaresBoard
            currentSquares={currentSquares}
            decideWinner={decideWinner}
            onNext={handleNext}
            whoNext={whoNext}
            auto={auto}
            player={symbol}
            pause={pause}
            setPause={setPause}
            stupid={stup}
            idiot={idi}
            intelligent={intelli}
            genius={geni}
            initial={init}
            starter={whoStart}
            bot={bot}
            exceptional={excep}
            audioRef={audioRef}
            audioRefBot={audioRefBot}
          ></SquaresBoard>
        </div>
        {!init && history.length > 1 ? (
          <div className="steps-container">
            {" "}
            <ul className="steps-adjust" style={{ listStyle: "none" }}>
              <li style={{ marginBottom: "10px" }} key="steps-header">
                <h3>Adjust Progress:</h3>
              </li>
              {steps}
            </ul>
          </div>
        ) : (
          <div className="steps-container">
            <ul className="steps-adjust" style={{ listStyle: "none" }}>
              <li style={{ marginBottom: "10px" }} key="steps-header">
                <h3>Adjust Progress:</h3>
              </li>
              <li key="play-again">
                <button className="step-bot" value="Play again" disabled>
                  Play again
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
      <footer className="social">
        <a
          href="https://github.com/farhan7reza7"
          title="Github Profile"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="github"></div>
        </a>
        <a
          href="https://www.facebook.com/farhan7reza5"
          title="Facebook Profile"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="facebook"></div>
        </a>
        <a
          href="https://www.linkedin.com/in/farhan7reza7"
          title="Linkedin Profile"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="linkedin"></div>
        </a>
        <a
          href="https://www.instagram.com/farhan7reza/"
          title="Instagram Profile"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="instagram"></div>
        </a>
        <a
          href="https://twitter.com/farhan7reza5"
          title="Twitter Profile"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="twitter"></div>
        </a>
        <a
          href="https://medium.com/@farhan7reza7"
          title="Medium Profile"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="medium"></div>
        </a>
      </footer>
    </div>
  );
}

function SquaresBoard({
  currentSquares,
  onNext,
  whoNext,
  decideWinner,
  auto,
  player,
  pause,
  setPause,
  stupid,
  idiot,
  intelligent,
  genius,
  initial,
  starter,
  bot,
  exceptional,
  audioRef,
  audioRefBot,
}) {
  const { lines } = useSelector((state) => state.static);
  // Haptic feedback with sound integration
  const vibrate = useCallback(
    (pattern = 10) => {
      if ("vibrate" in navigator) navigator.vibrate(pattern);
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        audioRefBot.current?.pause();
        audioRef.current.play();
      }
    },
    [audioRef, audioRefBot]
  );

  // handle click on squareboard
  const handleClick = useCallback(
    (index) => {
      if (pause || currentSquares[index] || decideWinner(currentSquares)) {
        return;
      }
      vibrate([20, 20, 30]);
      let newTurns = currentSquares.slice();
      newTurns[index] = whoNext;

      onNext(newTurns);
      bot ? setPause(true) : setPause(false);
    },
    [
      currentSquares,
      decideWinner,
      whoNext,
      onNext,
      pause,
      setPause,
      bot,
      vibrate,
    ]
  );
  // hanfle auto play
  const autoPlayer = useCallback(
    (currentSquares) => {
      let next = "",
        Xs = Array(9).fill(undefined), // player can be X/O
        Os = Array(9).fill(undefined); // auto

      currentSquares.forEach((value, index) => {
        if (value === player) {
          Xs[index] = value;
        } else if (value === auto) {
          Os[index] = value;
        }
      });

      // start logic to defend and conquer
      const center = 4;
      const corner = [0, 2, 6, 8];
      const inner = [1, 3, 5, 7];
      let Vs = currentSquares;
      let Xnum = Vs.filter((item) => item === player).length; // player all turns

      // logics to win
      function makeWin() {
        // step to win logic      // 2 O out of 3
        for (let i = 0; i < lines.length; i++) {
          const [a, b, c] = lines[i];

          // 2 O out of 3 // work as expected
          if (Os[a] === Os[b] && Os[a] !== undefined && Os[b] !== Os[c]) {
            if (!Xs[c]) {
              return c;
            }
          } else if (
            Os[c] !== Os[a] &&
            Os[b] === Os[c] &&
            Os[b] !== undefined
          ) {
            if (!Xs[a]) {
              return a;
            }
          } else if (
            Os[c] === Os[a] &&
            Os[c] !== undefined &&
            Os[a] !== Os[b]
          ) {
            if (!Xs[b]) {
              return b;
            }
          }
        }
      }

      // logics to defend lose
      function defendLose() {
        // step to defend logic // 2 X out of 3
        for (let i = 0; i < lines.length; i++) {
          const [a, b, c] = lines[i];

          // 2 X out of 3
          if (Xs[a] === Xs[b] && Xs[a] !== undefined && Xs[b] !== Xs[c]) {
            if (!Os[c]) {
              return c;
            }
          } else if (
            Xs[b] === Xs[c] &&
            Xs[b] !== undefined &&
            Xs[c] !== Xs[a]
          ) {
            if (!Os[a]) {
              return a;
            }
          } else if (
            Xs[c] === Xs[a] &&
            Xs[c] !== undefined &&
            Xs[a] !== Xs[b]
          ) {
            if (!Os[b]) {
              return b;
            }
          }
        }
      }

      // logics to prepare for win
      //function prepareWin() {}

      // logics to prepare for defend
      //function prepareDefend() {}

      // defend against trick when pl first
      function diagonalDefend(cornerUsed) {
        if (cornerUsed === 2) {
          if (Xs[0] !== Xs[4] && Xs[4] !== Xs[8] && Xs[0] && Xs[8]) {
            let randomIndex = Math.floor(Math.random() * 4);
            return inner[randomIndex];
          } else if (Xs[2] !== Xs[4] && Xs[4] !== Xs[6] && Xs[2] && Xs[6]) {
            let randomIndex = Math.floor(Math.random() * 4);
            return inner[randomIndex];
          }
        } else if (cornerUsed === 1) {
          if (Vs[0] !== Vs[4] && Vs[4] !== Vs[8] && (Vs[0] || Vs[8])) {
            if (!Vs[0]) {
              return 0;
            } else if (!Vs[8]) {
              return 8;
            }
          } else if (Vs[2] !== Vs[4] && Vs[4] !== Vs[6] && (Vs[2] || Vs[6])) {
            if (!Vs[2]) {
              return 2;
            } else if (!Vs[6]) {
              return 6;
            }
          }
        }
      }

      // choose random left space
      function restRandom() {
        let leftSpace = [];
        Vs.forEach((item, index) => {
          if (item === undefined) {
            leftSpace.push(index);
          }
        });
        let randomIndex = Math.floor(Math.random() * leftSpace.length);
        return leftSpace[randomIndex];
      }

      // return random  corner
      function randomCorner() {
        let randomIndex = Math.floor(Math.random() * 4);
        return corner[randomIndex];
      }

      // return any left corner
      function randomLeftCorner() {
        let leftCorners = Vs.filter(
          (value, index) => !Vs[index] && corner.includes(index)
        );
        let randomIndex = Math.floor(Math.random() * leftCorners);
        if (leftCorners) {
          return leftCorners[randomIndex];
        }
      }

      // return random corner or center
      function randomCornerCenter() {
        corner.push(center);
        let randomIndex = Math.floor(Math.random() * 5);
        return corner[randomIndex];
      }

      // when auto first and player use inner at 1st turn
      function autoFirstPlayerInner1(index) {
        let options;
        if (index === 1) {
          options = [0, 2];
          let randomIndex = Math.floor(Math.random() * options.length);
          return options[randomIndex];
        } else if (index === 3) {
          options = [0, 6];
          let randomIndex = Math.floor(Math.random() * options.length);
          return options[randomIndex];
        } else if (index === 5) {
          options = [2, 8];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        } else if (index === 7) {
          options = [6, 8];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        }
      }
      // check player corners use
      function palyerCorners() {
        let cornerUsed = 0;
        Xs.forEach((value, index) => {
          if (Xs[index] && corner.includes(index)) {
            cornerUsed += 1;
          }
        });
        return cornerUsed;
      }

      // check auto corners use
      function autoCorners() {
        let cornerUsed = 0;
        Os.forEach((value, index) => {
          if (Os[index] && corner.includes(index)) {
            cornerUsed += 1;
          }
        });
        return cornerUsed;
      }

      function returnCornerWhenOne(c) {
        if (!Xs[c]) {
          if (corner.includes(c)) {
            return c;
          } else {
            next = c;
          }
        }
      }

      // return any preferable or any from the rest spaces
      function anyPerferableRest() {
        // step to next step logic when 1 player out of 3 in any line
        for (let i = 0; i < lines.length; i++) {
          const [a, b, c] = lines[i];
          // 1x 2 un / 1x 1u 1o
          if (
            (Xs[a] !== Xs[b] && Xs[b] !== Xs[c]) ||
            (Xs[b] !== Xs[c] && Xs[c] !== Xs[a]) ||
            (Xs[c] !== Xs[a] && Xs[a] !== Xs[b])
          ) {
            let k = Xs[a],
              l = Xs[b],
              m = Xs[c];

            if (k) {
              // 1x 1u 1o / 1x 1o 1u
              // 0 auto out of 3 with 1 player
              if (Os[b] === Os[c] && Os[b] === undefined) {
                // 1 O out of 3
                if (Xs[b] === Xs[c] && Xs[b] === undefined) {
                  if (corner.includes(b)) {
                    return b;
                  } else if (corner.includes(c)) {
                    return c;
                  }
                }
              } else if (Os[b] && Os[b] !== Os[c]) {
                let squareIndex = returnCornerWhenOne(c);
                if (squareIndex || squareIndex === 0) {
                  return squareIndex;
                }
              } else if (Os[c] && Os[c] !== Os[b]) {
                let squareIndex = returnCornerWhenOne(b);
                if (squareIndex || squareIndex === 0) {
                  return squareIndex;
                }
              }
            } else if (l) {
              // 0 auto out of 3
              if (Os[a] === Os[c] && Os[a] === undefined) {
                if (Xs[a] === Xs[c] && Xs[a] === undefined) {
                  if (corner.includes(a)) {
                    return a;
                  } else if (corner.includes(c)) {
                    return c;
                  }
                }
                // 0 auto out of 3
              } else if (Os[c] && Os[a] !== Os[c]) {
                let squareIndex = returnCornerWhenOne(a);
                if (squareIndex || squareIndex === 0) {
                  return squareIndex;
                }
              } else if (Os[a] && Os[a] !== Os[c]) {
                let squareIndex = returnCornerWhenOne(c);
                if (squareIndex || squareIndex === 0) {
                  return squareIndex;
                }
              }
            } else if (m) {
              if (Os[b] === Os[a] && Os[b] === undefined) {
                if (Xs[b] === Xs[a] && Xs[b] === undefined) {
                  if (corner.includes(a)) {
                    return a;
                  } else if (corner.includes(b)) {
                    return b;
                  }
                }
              } else if (Os[a] && Os[b] !== Os[a]) {
                let squareIndex = returnCornerWhenOne(b);
                if (squareIndex || squareIndex === 0) {
                  return squareIndex;
                }
              } else if (Os[b] && Os[b] !== Os[a]) {
                let squareIndex = returnCornerWhenOne(a);
                if (squareIndex || squareIndex === 0) {
                  return squareIndex;
                }
              }
            }
          }
        }
        return next;
      }

      // trick if player use corner when auto first in its 2nd turn
      function trickCorner(index) {
        let options = [
          [0, 8],
          [2, 6],
        ];
        if (index === options[0][0]) {
          return options[0][1];
        } else if (index === options[0][1]) {
          return options[0][0];
        } else if (index === options[1][0]) {
          return options[1][1];
        } else if (index === options[1][1]) {
          return options[1][0];
        }
      }

      // trick when auto first and player use center at 1st turn
      function trickCenter() {
        let options = [
          [0, 8],
          [2, 6],
        ];

        if (
          !(
            Vs[options[0][0]] === Vs[options[0][1]] &&
            Vs[options[0][1]] === undefined
          )
        ) {
          if (Vs[options[0][0]] === undefined) {
            return options[0][0];
          } else if (Vs[options[0][1]] === undefined) {
            return options[0][1];
          }
        } else if (
          !(
            Vs[options[1][0]] === Vs[options[1][1]] &&
            Vs[options[1][1]] === undefined
          )
        ) {
          if (Vs[options[1][0]] === undefined) {
            return options[1][0];
          } else if (Vs[options[1][1]] === undefined) {
            return options[1][1];
          }
        }
      }

      // when auto starts and player not use corner // auto win
      // or when pl starts but not use center and 2 corners // auto win
      function playerNotCorner() {
        let option;
        let firstTurn;
        let leftCorners = [];
        let finalValue, otherValue;

        Xs.forEach((value, index) => {
          if (value && corner.includes(index)) {
            option = index;
          } else if (corner.includes(index) && !Vs[index]) {
            leftCorners.push(index);
          } else if (inner.includes(index) && Vs[index]) {
            firstTurn = index;
          } //
        });
        if (option || option === 0) {
          let allOptions = [
            firstTurn - 1,
            firstTurn + 1,
            firstTurn - 3,
            firstTurn + 3,
          ];
          allOptions.forEach((value, index) => {
            if (leftCorners.includes(value)) {
              otherValue = value;
              if (leftCorners.indexOf(otherValue) === 0) {
                finalValue = 1;
              } else if (leftCorners.indexOf(otherValue) === 1) {
                finalValue = 0;
              }
            }
          });

          if (finalValue || finalValue === 0) {
            return leftCorners[finalValue];
          }
        }
      }

      //return win or defending index
      function winDefend() {
        // win check
        next = makeWin();
        if (next || next === 0) {
          return next;
        }

        // defend check
        next = defendLose();
        if (next || next === 0) {
          return next;
        }
      }

      // trick inner when auto first and use inner at first turn
      function trickInner() {
        let indexAuto = Vs.indexOf(auto);
        let options;
        if (indexAuto === 1) {
          options = [6, 8];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        } else if (indexAuto === 3) {
          options = [2, 8];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        } else if (indexAuto === 5) {
          options = [0, 6];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        } else if (indexAuto === 7) {
          options = [0, 2];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        }
      }

      // defend inner trick when auto first and use inner at first turn
      function defendInner() {
        let indexPlayer = "";
        Xs.forEach((value, index) => {
          if (inner.includes(index) && Xs[index]) {
            indexPlayer = index;
          }
        });
        let options;
        if (indexPlayer === 1) {
          options = [0, 2];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        } else if (indexPlayer === 3) {
          options = [0, 6];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        } else if (indexPlayer === 5) {
          options = [2, 8];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        } else if (indexPlayer === 7) {
          options = [6, 8];
          let randomIndex = Math.floor(Math.random() * 2);
          return options[randomIndex];
        }
      }

      // check for bot then logics for that bot
      // logics for stupid bot
      if (stupid) {
        // return any random left space
        next = restRandom();
        if (next || next === 0) {
          return next;
        }

        // logics for average bot
      } else if (idiot) {
        //return win or defending index
        next = winDefend();
        if (next || next === 0) {
          return next;
        }

        // return any random rest space
        next = restRandom();
        if (next || next === 0) {
          return next;
        }

        // logics for intelligent bot
      } else if (intelligent) {
        if (!Xnum) {
          return center;
          // second step
        } else if (Xnum === 1) {
          let index = currentSquares.indexOf(player);
          if (starter !== auto) {
            if (index === center) {
              return randomCorner();
            } else {
              return center;
            }
          } else {
            // return any rest corner
            next = randomLeftCorner();
            if (next || next === 0) {
              return next;
            }
          }
        } else if (Xnum >= 2) {
          //return win or defending index
          next = winDefend();
          if (next || next === 0) {
            return next;
          }

          // return any random rest space
          next = restRandom();
          if (next || next === 0) {
            return next;
          }
        }
      } else if (genius) {
        // first step when auto start
        if (!Xnum) {
          // return random corner or center
          return randomCornerCenter();
          // second step
        } else if (Xnum === 1) {
          let index = currentSquares.indexOf(player);

          if (starter !== auto) {
            if (index === center) {
              return randomCorner();
            } else {
              return center;
            }
            // if bot starts
          } else {
            if (!Vs[center]) {
              return center;
            } else if (!corner.includes(index) && Os[center]) {
              // when auto first and player use inner at 1st turn
              next = autoFirstPlayerInner1(index);
              if (next || next === 0) {
                return next;
              }
            } else {
              // return any rest corner
              next = randomLeftCorner();
              if (next || next === 0) {
                return next;
              }
            }
          }
        } else if (Xnum >= 2) {
          //return win or defending index
          next = winDefend();
          if (next || next === 0) {
            return next;
          }
          if (starter === player) {
            // return any preferable or any from the rest spaces
            next = anyPerferableRest();
            if (next || next === 0) {
              return next;
            }
          } else {
            // return any random rest space
            next = restRandom();
            if (next || next === 0) {
              return next;
            }
          }
        }
        // at the end, return any rest
        return next;
      } else if (exceptional) {
        // first step when auto start
        if (!Xnum) {
          // return random corner or center
          //return randomCornerCenter();
          // return any random left space
          return restRandom();
          // second step
        } else if (Xnum === 1) {
          let index = Vs.indexOf(player);

          if (starter !== auto) {
            if (index === center) {
              return randomCorner();
            } else {
              return center;
            }
            // if bot starts
          } else {
            if (!Vs[center]) {
              // if center un when auto first in its 2nd turn
              return center;
              // if pl use corner when auto first in its 2nd turn
            } else if (corner.includes(index) && Os[center]) {
              // trick if player use corner when auto first in its 2nd turn
              next = trickCorner(index);
              if (next || next === 0) {
                return next;
              }
              // if pl use inner when auto first in its 2nd turn
            } else if (inner.includes(index) && Vs[center]) {
              // when auto first and player use inner at 1st turn
              next = autoFirstPlayerInner1(index);
              if (next || next === 0) {
                return next;
              }
            } else if (index === center) {
              // trick when auto first and player use center at 1st turn
              next = trickCenter();
              if (next || next === 0) {
                return next;
              }

              // trick inner when auto first and use inner at first turn
              next = trickInner();
              if (next || next === 0) {
                return next;
              }
            }
          }
        } else if (Xnum >= 2) {
          //return win or defending index
          next = winDefend();
          if (next || next === 0) {
            return next;
          }
          if (Xnum === 2) {
            // check player corners use
            let cornerUsed = palyerCorners();
            let autoCornerUsed = autoCorners();

            // when pl second and use center or inner only
            if (starter === auto && cornerUsed && !Xs[center]) {
              // when auto starts and player not use corner // auto win
              // or when pl starts but not use center and 2 corners // auto win
              if (cornerUsed === 1 && autoCornerUsed) {
                next = playerNotCorner();
                if (next || next === 0) {
                  return next;
                }
              } else if (!autoCornerUsed) {
                // defend inner trick when auto first and use inner at first turn
                next = defendInner();
                if (next || next === 0) {
                  return next;
                }
              }
            } else if (starter === player && cornerUsed && !Xs[center]) {
              // defend against tricks when pl first
              next = diagonalDefend(cornerUsed);
              if (next || next === 0) {
                return next;
              }
            }
          }
          // return any preferable or any from the rest spaces
          next = anyPerferableRest();
          if (next || next === 0) {
            return next;
          }
        }
        // at the end, return any rest
        return next;
      }
    },
    [
      auto,
      player,
      genius,
      idiot,
      stupid,
      intelligent,
      starter,
      exceptional,
      lines,
    ]
  );

  let leftSpace = currentSquares.filter((item) => item === undefined).length;

  useEffect(() => {
    if (
      whoNext === auto &&
      !decideWinner(currentSquares) &&
      leftSpace &&
      !initial &&
      bot
    ) {
      // here can diff for diff
      let squareIndex = autoPlayer(currentSquares);

      //console.log("squareIndex ", squareIndex);
      if (currentSquares[squareIndex]) {
        return;
      }

      setTimeout(() => {
        let newTurns = currentSquares.slice();
        newTurns[squareIndex] = whoNext;

        if ("vibrate" in navigator) navigator.vibrate(10);
        if (audioRefBot.current) {
          audioRefBot.current.currentTime = 0;
          audioRef.current?.pause();
          audioRefBot.current.play();
        }

        onNext(newTurns);
        setPause(false);
      }, 2000);
    }
  }, [
    whoNext,
    initial,
    bot,
    decideWinner,
    auto,
    autoPlayer,
    currentSquares,
    leftSpace,
    onNext,
    setPause,
    audioRefBot,
    audioRef,
  ]);

  let won = decideWinner(currentSquares);

  const squares = currentSquares.map((el, index) => {
    if (won && won.includes(index)) {
      return (
        <Square
          key={index}
          pause={pause}
          won={won}
          leftSpace={leftSpace}
          onClick={() => handleClick(index)}
          num={<span className="won-square">{el}</span>}
        ></Square>
      );
    } else {
      return (
        <Square
          key={index}
          onClick={() => handleClick(index)}
          num={el}
          pause={pause}
          won={won}
          leftSpace={leftSpace}
        ></Square>
      );
    }
  });

  return (
    <>
      <div id="squares-board">{squares}</div>
    </>
  );
}

function Square({ onClick, num, pause, won, leftSpace }) {
  return (
    <button
      className="square"
      style={{
        cursor:
          pause || won || !leftSpace
            ? "not-allowed"
            : num
            ? "default"
            : "pointer",
      }}
      onClick={onClick}
    >
      {num}
    </button>
  );
}

function RowMaker({ opponent, score }) {
  let value = score[opponent];
  return (
    <tr>
      <td>{opponent}</td>
      <td className={value.win ? "scored-value" : ""}>{value.win}</td>
      <td className={value.lose ? "scored-value" : ""}>{value.lose}</td>
      <td className={value.tie ? "scored-value" : ""}>{value.tie}</td>
      <td className={value.total ? "scored-value" : ""}>{value.total}</td>
    </tr>
  );
}

const ScoreRows = ({ score }) => {
  let scores = [];
  for (let opponent in score) {
    scores.push(
      <RowMaker opponent={opponent} score={score} key={opponent}></RowMaker>
    );
  }
  return (
    <table>
      <thead>
        <tr>
          <th>Opponent</th>
          <th>you won</th>
          <th>you lose</th>
          <th>tie</th>
          <th>total</th>
        </tr>
      </thead>
      <tbody>{scores}</tbody>
    </table>
  );
};
